import { Box, Button, styled, Typography, useTheme } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { activeTab } from "../../../assets";
import { NftCard } from "../../../components/NftCard";
import { NoData } from "../../../components/NoData";
import { ON_LEND, ON_RENT, IN_INVENTORY } from "../../../constants";
import { forceClaim, unLendNft } from "../../../contract";
import { myNFTs } from "../../../data/dummyNfts";
import { useAPIActions, useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { setLoading } from "../../../state/action-creators/UIActionCreator";
import { tokens } from "../../../theme";
import {
  getAccumulatedYield,
  getBorrowersForLender,
  getKeyForYieldClaim,
  getKeyForYieldClaimLender,
  onYieldDistribution,
} from "../../../utils/wallet/apiHelpers";
import AssetTableView from "./AssetTableView";
import TableView from "./AssetTableView";

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "272px",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  marginLeft: "20px",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

export const AssetDetails = ({
  view,
  NftBoxProps,
  profileNfts,
  setProfileNfts,
  setStep,
  searchVar,
  searchShow,
  filtered,
  setFiltered,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account, chainId } = useWeb3React();
  const [currStatus, setCurrStatus] = useState("Available");

  const { setSnackbar, setLoading } = useUIActions();
  const { updateProfileNftsOnBulkLend } = useAPIActions();
  const profileNftsFromRedux = useTypedSelector(
    (state) => state.apiReducer.profileNfts
  );
  // const [profileNfts, setProfileNfts] = useState(
  //   profileNftsFromRedux.map((nft) => {
  //     return { ...nft, selected: false };
  //   })
  // );

  const [collectionAddress, setCollectionAddress] = useState("");
  const [operation, setOperation] = useState("bulk-lend");

  const [droppedNfts, setDroppedNfts] = useState([]);
  const [scholarAddress, setScholarAddress] = useState("");
  const [split, setSplit] = useState("");
  const [selectedNft, setSelectedNft] = useState(
    profileNfts.filter((nftP) => nftP.selected)
  );

  useEffect(() => {
    setProfileNfts(
      profileNftsFromRedux.map((nft) => {
        return { ...nft, selected: false };
      })
    );
  }, [JSON.stringify(profileNftsFromRedux)]);

  useEffect(() => {
    setSelectedNft(profileNfts.filter((nft) => nft.selected));
  }, [profileNfts]);

  const setNftStaesOnSelectOnLoan = (
    dataForProfileNfts,
    itemToRemoveFromDroppedNfts
  ) => {
    console.log("inside main", dataForProfileNfts);
    const tempProfileNfts = profileNfts.map((nftP) => {
      if (
        nftP.lendingId === itemToRemoveFromDroppedNfts.lendingId &&
        nftP.tokenId === itemToRemoveFromDroppedNfts.tokenId &&
        nftP.nftAddress === itemToRemoveFromDroppedNfts.nftAddress
      ) {
        return { ...nftP, selected: !nftP.selected };
      } else {
        return nftP;
      }
    });
    const tempSelectedNft = tempProfileNfts.filter((nft) => nft.selected);

    console.log(
      "every condition",
      collectionAddress,
      tempSelectedNft,

      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    );

    if (tempProfileNfts.filter((nft) => nft.selected).length === 0) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft([]);
      setCollectionAddress("");
    }

    if (tempProfileNfts.filter((nft) => nft.selected).length >= 1) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
    }

    setDroppedNfts(
      droppedNfts.filter(
        (nftD) => nftD.tokenId !== itemToRemoveFromDroppedNfts.tokenId
      )
    );
  };

  const setNftStaesOnSelect = (
    dataForProfileNfts,
    itemToRemoveFromDroppedNfts
  ) => {
    console.log("inside main", dataForProfileNfts);
    const tempProfileNfts = profileNfts.map((nftP) => {
      if (
        nftP.tokenId === itemToRemoveFromDroppedNfts.tokenId &&
        nftP.nftAddress === itemToRemoveFromDroppedNfts.nftAddress
      ) {
        return { ...nftP, selected: !nftP.selected };
      } else {
        return nftP;
      }
    });
    const tempSelectedNft = tempProfileNfts.filter((nft) => nft.selected);

    console.log(
      "every condition",
      collectionAddress,
      tempSelectedNft,

      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    );

    if (tempProfileNfts.filter((nft) => nft.selected).length === 0) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft([]);
      setCollectionAddress("");
    }

    if (tempProfileNfts.filter((nft) => nft.selected).length === 1) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      !tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setSnackbar({
        open: true,
        severity: "info",
        message: `Cannot select Nfts other than ${
          tempSelectedNft.filter(
            (nft) => nft.selected && collectionAddress === nft.nftAddress
          )[0].contractName
        } collection`,
      });
    }

    setDroppedNfts(
      droppedNfts.filter(
        (nftD) => nftD.tokenId !== itemToRemoveFromDroppedNfts.tokenId
      )
    );
  };

  const reclaimCallback = async (msg, status) => {
    setLoading(false);
    setSnackbar({
      open: true,
      severity: status ? "success" : "error",
      message: msg,
    });
    if (status) {
      const lendingIds = selectedNft.map((nft) => nft.lendingId);
      const updNfts = profileNftsFromRedux.map((nft) => {
        if (lendingIds.includes(nft.lendingId)) {
          return {
            ...nft,
            status: IN_INVENTORY,
          };
        } else {
          return nft;
        }
      });
      await updateProfileNftsOnBulkLend(updNfts, chainId);
    }
  };

  const yieldDistribute = async (encKey, borrower, rewardTokenAddress) => {
    try {
      const resp = await getKeyForYieldClaimLender(encKey, account);
      console.log("resp for key", resp);
      const finalResp = await onYieldDistribution(
        resp,
        account.toLowerCase(),
        borrower.toLowerCase(),
        rewardTokenAddress.toLowerCase()
      );
      console.log("finalResp", finalResp);
      return finalResp;
    } catch (e) {
      console.log("yielddistribute error", e);
      return false;
    }
  };

  const onReclaimNfts = async () => {
    try {
      setLoading(true);

      const lendingIds = selectedNft.map((nft) => nft.lendingId);

      const nftsToClaimYieldOn = selectedNft.filter(
        (nft) => nft.status === ON_RENT
      );
      console.log("nftsToClaimYieldOn", nftsToClaimYieldOn, selectedNft);

      let borrowers = await getBorrowersForLender(account);

      if (borrowers.length) {
        console.log("borrowers getBorrowersForLender ", borrowers);

        let yieldRecords = [];

        borrowers.forEach(async (col) => {
          await nftsToClaimYieldOn.forEach((nft) => {
            if (
              col.borrowerEOA.toLowerCase() === nft?.borrower.toLowerCase() &&
              col.rewardTokenAddress.toLowerCase() ===
                nft?.rewardTokenAddress.toLowerCase() &&
              col.lenderAddress.toLowerCase() === nft?.lender?.id.toLowerCase()
            ) {
              yieldRecords.push({
                ...nft,
                ...col,
              });
            }
          });
        });

        console.log("yieldRecords", yieldRecords);

        if (yieldRecords.length) {
          // checking if lender is eligible for claiming yield
          const allTimestamps = yieldRecords.map(
            (borrower) => borrower?.inPlatformTxTimeStamp
          );
          let currentDate = Math.floor(Date.now() / 1000);
          console.log(
            "allTimestamps.some(timestamp => timestamp > currentDate)",
            allTimestamps,
            allTimestamps.every((timestamp) => timestamp > currentDate)
          );
          if (!allTimestamps.every((timestamp) => timestamp > currentDate)) {
            const accumulateYield = await Promise.all(
              yieldRecords.map(async (scy) => {
                const resp = await getAccumulatedYield(
                  scy.lenderAddress,
                  scy.borrowerEOA,
                  scy.rewardTokenAddress
                );
                console.log("resp", resp);
                return {
                  ...scy,
                  resp,
                };
              })
            );

            console.log("accumulateYield", accumulateYield);

            const yieldExistedRecords = accumulateYield.filter(
              (accYield) => !accYield?.resp?.status
            );

            const uniqueYieldExistedRecords = yieldExistedRecords.filter(
              (a, i) =>
                yieldExistedRecords.findIndex(
                  (s) => a.rewardTokenAddress === s.rewardTokenAddress
                ) === i
            );

            //count for unique reward token addresses
            const tokenEligibleForYieldDistributionCount =
              uniqueYieldExistedRecords.length;

            console.log("yieldExistedRecords", {
              yieldExistedRecords,
              uniqueYieldExistedRecords,
              tokenEligibleForYieldDistributionCount,
            });

            if (uniqueYieldExistedRecords.length) {
              const yieldDistribution = await Promise.all(
                uniqueYieldExistedRecords.map((yieldExisted) => {
                  return yieldDistribute(
                    yieldExisted.encrptedPubKey,
                    yieldExisted.borrowerEOA,
                    yieldExisted.rewardTokenAddress
                  );
                })
              );
              console.log(
                "yieldDistribution FINALFINALFINAL",
                yieldDistribution
              );
            }
          }
        }
      }
      await unLendNft(lendingIds, account, reclaimCallback);
    } catch (e) {
      console.log("error on reclaim", e);
    }
  };

  console.log(
    "filtered",
    profileNfts.filter(
      (nft) =>
        (nft.status === ON_RENT && currStatus === "On Loan") ||
        nft.status === currStatus
    )
  );

  return (
    <Box display="flex" flexDirection={"column"} width="98%">
      <Box
        sx={{
          width: "100%",
          borderBottom: "2px solid #E8ECF5",
          display: "flex",
          flexDirection: "row",
          paddingLeft: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "20px",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => setCurrStatus("Available")}
        >
          <Typography variant="fs13" fontWeight={500} color={colors.black[200]}>
            Available
          </Typography>

          <img
            src={activeTab}
            alt={"active"}
            style={{
              width: "64px",
              height: "10px",
              visibility: currStatus === ON_LEND ? "hidden" : "visible",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "20px",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => setCurrStatus(ON_LEND)}
        >
          <Typography variant="fs13" fontWeight={500} color={colors.black[200]}>
            On Loan
          </Typography>
          <img
            src={activeTab}
            alt={"active"}
            style={{
              width: "64px",
              height: "10px",
              visibility: currStatus === ON_LEND ? "visible" : "hidden",
            }}
          />
        </Box>
      </Box>

      {searchShow &&
      filtered.filter(
        (nft) =>
          (nft.status === ON_RENT && currStatus === "On Loan") ||
          nft.status === currStatus
      ).length > 0 ? (
        view === "gallery" ? (
          <Box {...NftBoxProps()}>
            {filtered
              .filter(
                (nft) =>
                  (nft.status === ON_RENT && currStatus === "On Loan") ||
                  nft.status === currStatus
              )
              .map((item, index) => (
                <Box gridColumn="span 5" gridRow="span 3">
                  <NftCard
                    image={item.image}
                    collectionName={item.contractName}
                    name={item.name}
                    tokenId={item.tokenId}
                    status={item.status}
                    address={item.nftAddress}
                    key={index}
                    forScholar={true}
                    currNft={item}
                    profileNfts={filtered}
                    setNftStaesOnSelect={
                      currStatus === "On Loan"
                        ? setNftStaesOnSelectOnLoan
                        : setNftStaesOnSelect
                    }
                    setFilteredNfts={setFiltered}
                  />
                </Box>
              ))}
          </Box>
        ) : (
          <AssetTableView
            data={filtered.filter(
              (nft) =>
                (nft.status === ON_RENT && currStatus === "On Loan") ||
                nft.status === currStatus
            )}
            setNftStaesOnSelect={
              currStatus === "On Loan"
                ? setNftStaesOnSelectOnLoan
                : setNftStaesOnSelect
            }
            setFilteredNfts={setFiltered}
          />
        )
      ) : searchShow &&
        filtered.filter(
          (nft) =>
            (nft.status === ON_RENT && currStatus === "On Loan") ||
            nft.status === currStatus
        ).length === 0 ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <NoData text="No Nft to show!" />
        </Box>
      ) : profileNfts.filter(
          (nft) =>
            (nft.status === ON_RENT && currStatus === "On Loan") ||
            nft.status === currStatus
        ).length > 0 ? (
        view === "gallery" ? (
          <Box {...NftBoxProps()}>
            {profileNfts
              .filter(
                (nft) =>
                  (nft.status === ON_RENT && currStatus === "On Loan") ||
                  nft.status === currStatus
              )
              .map((item, index) => (
                <Box gridColumn="span 5" gridRow="span 3">
                  <NftCard
                    image={item.image}
                    collectionName={item.contractName}
                    name={item.name}
                    tokenId={item.tokenId}
                    status={item.status}
                    address={item.nftAddress}
                    selected={item.selected}
                    key={index}
                    forScholar={true}
                    currNft={item}
                    profileNfts={profileNfts}
                    setNftStaesOnSelect={
                      currStatus === "On Loan"
                        ? setNftStaesOnSelectOnLoan
                        : setNftStaesOnSelect
                    }
                  />
                </Box>
              ))}
          </Box>
        ) : (
          <AssetTableView
            data={profileNfts.filter(
              (nft) =>
                (nft.status === ON_RENT && currStatus === "On Loan") ||
                nft.status === currStatus
            )}
            setNftStaesOnSelect={
              currStatus === "On Loan"
                ? setNftStaesOnSelectOnLoan
                : setNftStaesOnSelect
            }
          />
        )
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <NoData text="No Nft to show!" />
        </Box>
      )}

      <Box
        display="flex"
        flexDirection="row"
        width="97%"
        marginBottom="10px"
        marginTop="50px"
        alignItems={"center"}
        justifyContent={"center"}
        pl={1}
      >
        <StyledButton
          onClick={() => {
            if (currStatus === "Available") {
              setStep(1);
            } else {
              onReclaimNfts();
            }
          }}
          variant="outlined"
          colors={colors}
          disabled={!selectedNft.length}
        >
          {currStatus === ON_LEND ? "Reclaim NFT" : "Yield Split"}
        </StyledButton>
      </Box>
    </Box>
  );
};
